import { theme } from '@adflow/frontend/ui-theme';
import type { ViewHistoryGMBTemplateDto } from '@adflow/shared/util-history';

import { HistoryGMBTemplate } from '../../History/HistoryGMBTemplate';
import { HistoryTemplateUpload } from '../../History/HistoryTemplateUpload';

const styles = {
	container: {
		padding: '1rem',
		width: '100%',
		maxWidth: theme.screens.xl,
	},
};

interface GMBHistoryRowExpandedProps {
	history: ViewHistoryGMBTemplateDto;
	onClose: () => void;
}

export function GMBHistoryRowExpanded({ history }: GMBHistoryRowExpandedProps) {
	switch (history.action) {
		case 'CREATE':
		case 'UPDATE': {
			// Only pass changes for CREATE/UPDATE where data structure matches expected type
			const templateChanges = {
				oldData: 'oldData' in history ? (history.oldData ?? null) : null,
				newData: history.newData,
			};

			return (
				<div style={styles.container}>
					<HistoryGMBTemplate data={templateChanges} />
				</div>
			);
		}
		case 'UPLOAD': {
			// Transform Facebook upload data to generic format
			const uploadResults = (history.newData.results || []).map((result) => ({
				id: result.location,
				isSuccess: result.status === 'SUCCESS',
				errors:
					result.status === 'SUCCESS'
						? []
						: result.errors.map((error) => ({ message: error })),
			}));

			return (
				<div style={styles.container}>
					<HistoryTemplateUpload results={uploadResults} />
				</div>
			);
		}
		default: {
			return <div>Unknown action type</div>;
		}
	}
}
